import { query, where } from "firebase/firestore";
import { DateTime } from "luxon";

//////////////////////Mobile//////////////////
// // Firebase version 8
// import firebase from "firebase/app";
// import "firebase/auth";
// import "firebase/database";
// import "firebase/firestore";
// import "firebase/functions";
// import "firebase/storage";
// import { Analytics, Event } from "expo-analytics";
// import { Platform } from "react-native";
/////////////////////////////////

////////////////////Web/////////////////////
// Firebase version 9
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/database";
import "firebase/compat/firestore";
import "firebase/compat/functions";
import "firebase/compat/storage";
//import ReactGA from "react-ga";
import ReactGA from "react-ga4";
import Place from "../Models/Place";
import { buildGuideSummary } from "../Common/wanderlistSummary";
import { checkGuideSize } from "../Common/guideSize";
import { emailCandidates } from "../Common/emailLookup";
import { splitUser, mergeUser, legacyPrivate, emailKey } from "../Common/userPrivacy";
import { reportDocId, reportFields } from "../Common/shareInvites";
////////////////////////////////////////////

// YellowBox.ignoreWarnings([
//   "Setting a timer for a long period of time", // TODO: Remove when fixed
// ]);
//console.disableYellowBox = true;
//LogBox.ignoreLogs(["Setting a timer for a long period of time"]);
// Optionally import the services that you want to use
//import "firebase/auth";
//import "firebase/database";
//import "firebase/firestore";
//import "firebase/functions";
//import "firebase/storage";

// Initialize Firebase
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

if (!firebase.apps.length) {
  const app = firebase.initializeApp(firebaseConfig);
}

// DIY analytics — logs straight to Firestore instead of a dedicated
// analytics SDK. Fire-and-forget: never let a logging failure affect the
// real operation it's attached to. See memory: DIY Firestore analytics plan.
export function logAnalyticsEvent(type, fields = {}) {
  try {
    firebase
      .firestore()
      .collection("analytics_events")
      .add({
        type,
        platform: "web",
        ts: firebase.firestore.FieldValue.serverTimestamp(),
        ...fields,
      })
      .catch(() => {});
  } catch (e) {
    // swallow — analytics must never break the real operation
  }
}

// Guide views (2026-10-13) — who actually looks at a guide, for judging
// which videos and posts bring people in. Unlike guide_read / times_read,
// which skip signed-out visitors (and, since the rules were tightened, can
// only be bumped by the owner), this counts EVERYONE, once per guide per
// page session, and leaves out a guide's own owner so the author's testing
// doesn't count. `entry` is "link" when the page was opened on this guide's
// own link (?id=… — what a video's QR code or a shared link does), "app"
// when the guide was picked inside the app; `src` is the optional tag on a
// link (?src=pin, tt, ig, fb…).
const ENTRY_PARAMS = (() => {
  try {
    const q = new URLSearchParams(window.location.search);
    return { id: q.get("id") || "", src: String(q.get("src") || "").replace(/[^A-Za-z0-9_-]/g, "").slice(0, 24) };
  } catch (e) {
    return { id: "", src: "" };
  }
})();
// First-visit funnel (2026-10-13): arrived → opened a guide → interacted →
// signed up, and what first brought each new account in. A browser gets a
// random visitor id (no personal data) and remembers its first touch: the
// guide link it arrived on, any ?src= tag, and the site it came from. "New"
// = the id was made on this page load AND nobody is signed in: an existing
// user meeting this code for the first time still has their session, so
// they aren't counted as new. (Not "storage is empty" — the ad pixels in
// index.html write to it before the app starts.)
const VISITOR = (() => {
  const out = { vid: "", created: false, first: null };
  try {
    const ls = window.localStorage;
    out.vid = ls.getItem("andiamo_vid") || "";
    if (!out.vid) {
      out.created = true;
      out.vid = Math.random().toString(36).slice(2, 12) + Date.now().toString(36);
      let ref = "";
      try { ref = document.referrer ? new URL(document.referrer).hostname.replace(/^www\./, "").slice(0, 40) : ""; } catch (e) { ref = ""; }
      if (ref === window.location.hostname.replace(/^www\./, "")) ref = "";
      out.first = { ts: Date.now(), guide: ENTRY_PARAMS.id, src: ENTRY_PARAMS.src, ref };
      ls.setItem("andiamo_vid", out.vid);
      ls.setItem("andiamo_first", JSON.stringify(out.first));
    } else {
      out.first = JSON.parse(ls.getItem("andiamo_first") || "null");
    }
  } catch (e) {
    // storage blocked (private mode etc.) — the visit just isn't tracked
  }
  return out;
})();
// People only (2026-10-13). When a link is posted or saved on Facebook or
// Instagram, Meta opens it in automated browsers that run the page's code —
// on day one, every "new visitor" recorded was one of those: pairs of fresh
// browsers a second apart, the moment a link was saved, none ever touching
// the page. So a visit, view or interaction is only recorded once a human
// signal has been seen (a tap, key press, mouse move or wheel — not
// "scroll", which the app itself triggers), and never for a browser that
// declares itself automated. Such events carry h: 1; the dashboard counts
// only those for the web.
const AUTOMATED_BROWSER = (() => {
  try {
    if (navigator.webdriver === true) return true;
    return /bot\b|crawl|spider|facebookexternalhit|facebot|headless|lighthouse|phantomjs|prerender|slurp|google-inspectiontool|googleother|bingpreview|whatsapp\/|skypeuripreview|embedly|quora link preview|vkshare|w3c_validator/i.test(navigator.userAgent || "");
  } catch (e) {
    return false;
  }
})();
let humanSeen = false;
const waitingForHuman = [];
const HUMAN_SIGNALS = ["pointerdown", "touchstart", "keydown", "mousemove", "wheel"];
// How the person first showed up, how soon (seconds after the page started)
// and on what kind of device — recorded on every visitor event (2026-10-14).
// Google's link scanner got past "a person was seen" on the first day of
// YouTube links: 13 fresh browsers in three minutes, moving a simulated mouse
// and nothing else. Nothing is dropped for this; the dashboard sets aside
// "computer + mouse movement only" visitors as possibly automated.
const firstSignal = { sig: "", dt: 0, dev: "" };
function onHumanSignal(e) {
  humanSeen = true;
  try {
    firstSignal.sig = e && e.type ? (e.type === "touchstart" ? "touch" : e.type === "pointerdown" ? "click" : e.type) : "";
    firstSignal.dt = Math.round((typeof performance !== "undefined" ? performance.now() : 0) / 100) / 10;
    firstSignal.dev = window.matchMedia && window.matchMedia("(pointer: coarse)").matches ? "touch" : "desktop";
  } catch (err) {
    // keep going without the details
  }
  HUMAN_SIGNALS.forEach((t) => document.removeEventListener(t, onHumanSignal, true));
  waitingForHuman.splice(0).forEach((fn) => { try { fn(); } catch (e) { /* analytics only */ } });
}
try {
  if (!AUTOMATED_BROWSER) HUMAN_SIGNALS.forEach((t) => document.addEventListener(t, onHumanSignal, { capture: true, passive: true }));
} catch (e) {
  // no document (tests) — nothing is recorded
}
// Records a visitor event now if a person has been seen, else when one is.
function logWhenHuman(type, fields) {
  if (AUTOMATED_BROWSER) return;
  const send = () => logAnalyticsEvent(type, { ...fields, h: 1, sig: firstSignal.sig, dt: firstSignal.dt, dev: firstSignal.dev });
  if (humanSeen) send();
  else waitingForHuman.push(send);
}
const oncePerTabSession = (key) => {
  try {
    if (window.sessionStorage.getItem(key)) return false;
    window.sessionStorage.setItem(key, "1");
    return true;
  } catch (e) {
    return false;
  }
};
// One "visit" per browser tab session. Called once when the app starts.
export function logVisit() {
  if (!VISITOR.vid || !oncePerTabSession("andiamo_visit_logged")) return;
  const send = (signedIn) => {
    const isNew = VISITOR.created && !signedIn;
    logWhenHuman("visit", {
      uid: "guest",
      vid: VISITOR.vid,
      new: isNew,
      ...(ENTRY_PARAMS.id ? { guide_id: ENTRY_PARAMS.id } : {}),
      ...(ENTRY_PARAMS.src ? { src: ENTRY_PARAMS.src } : {}),
      ...(isNew && VISITOR.first?.ref ? { ref: VISITOR.first.ref } : {}),
    });
  };
  // Wait for the saved session (if any) to be restored before deciding.
  try {
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      unsubscribe();
      send(!!user && !user.isAnonymous);
    });
  } catch (e) {
    send(false);
  }
}
// "Interacted": the third tap after opening somebody else's guide — a
// visitor who looked around, not one who bounced. Once per tab session.
function watchForEngagement(guide_info_id, guest) {
  try {
    if (!VISITOR.vid || window.sessionStorage.getItem("andiamo_engaged")) return;
    let taps = 0;
    const onTap = () => {
      taps++;
      if (taps < 3) return;
      document.removeEventListener("pointerdown", onTap, true);
      if (oncePerTabSession("andiamo_engaged")) logWhenHuman("engage", { uid: "guest", vid: VISITOR.vid, guest, guide_id: guide_info_id });
    };
    document.addEventListener("pointerdown", onTap, true);
  } catch (e) {
    // never let analytics break the page
  }
}
// What first brought this browser in, for the signup event.
const firstTouchFields = () => ({
  ...(VISITOR.vid ? { vid: VISITOR.vid } : {}),
  ...(VISITOR.first?.guide ? { first_guide: VISITOR.first.guide } : {}),
  ...(VISITOR.first?.src ? { first_src: VISITOR.first.src } : {}),
  ...(VISITOR.first?.ref ? { first_ref: VISITOR.first.ref } : {}),
  ...(VISITOR.first?.ts ? { days_since_first: Math.floor((Date.now() - VISITOR.first.ts) / 86400000) } : {}),
});

// Same id as Common.js's SAMPLE_GUIDE_ID (not imported: Common is a heavy
// module this file shouldn't depend on).
const AUTO_LOADED_SAMPLE_GUIDE_ID = "JRm5fzCadsiWIYynzZoJ";
const guidesViewedThisSession = new Set();
// The guide now open in the app — a copy made next is a copy of this one.
let lastOpenedGuideInfoId = null;
function logGuideView(guide_info_id, infoDoc) {
  try {
    lastOpenedGuideInfoId = guide_info_id;
    const me = firebase.auth().currentUser;
    const uid = me && !me.isAnonymous ? me.uid : null;
    if (uid && infoDoc && infoDoc.user_id === uid) return;
    // The sample guide the app loads by itself for a visitor with no guide
    // of their own isn't something they chose to open.
    if (guide_info_id === AUTO_LOADED_SAMPLE_GUIDE_ID && ENTRY_PARAMS.id !== guide_info_id) return;
    if (guidesViewedThisSession.has(guide_info_id)) return;
    guidesViewedThisSession.add(guide_info_id);
    logWhenHuman("guide_view", {
      uid: uid || "guest",
      guest: !uid,
      guide_id: guide_info_id,
      featured: infoDoc?.type === "Featured",
      entry: ENTRY_PARAMS.id === guide_info_id ? "link" : "app",
      ...(ENTRY_PARAMS.src ? { src: ENTRY_PARAMS.src } : {}),
      ...(VISITOR.vid ? { vid: VISITOR.vid } : {}),
    });
    watchForEngagement(guide_info_id, !uid);
  } catch (e) {
    // analytics must never break the read
  }
}

export default class DataBase {
  static _isGuest = (uid) => !uid || uid === "guest";
  static _guestBlock = (callback) => {
    if (callback) callback({ pass: false, res: "Writes to cloud are not allowed in guest mode" });
  };
  // Guide size check before any guide_data write (Common/guideSize.js):
  // a guide too close to Firestore's 1 MiB document limit is refused here,
  // with nothing written, and the callback gets { pass: false, tooLarge,
  // res: message }. Otherwise returns the check, whose "warn" message the
  // save callbacks pass on as sizeWarning.
  static _sizeGate = (dataString, callback) => {
    const size = checkGuideSize(dataString);
    if (size.level === "block") {
      console.log("Guide too large to save", size.bytes);
      if (callback) callback({ pass: false, tooLarge: true, res: size.message, error: new Error(size.message) });
      return null;
    }
    return size;
  };

  static onAuthStateChanged = (callback) => {
    firebase.auth().onAuthStateChanged((user) => {
      //if (user) {
      callback(user);
      //}
    });
  };

  static getCurrentUser = () => firebase.auth().currentUser ?? null;

  static SignUp = (email, password, callback) => {
    // try {
    firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then((user) => {
        callback({ pass: true, res: user });
      })
      .catch((error) => {
        callback({ pass: false, res: error });
      });

    // } catch (error) {
    //console.log(error.toString(error));
    //   callback(error);
    // }
  };

  static SignUpWithLink = (email, callback) => {
    const actionCodeSettings = {
      // URL you want to redirect back to. The domain (www.example.com) for this
      // URL must be in the authorized domains list in the Firebase Console.
      url: "https://andiamotravelapp.page.link/register",
      // This must be true.
      handleCodeInApp: true,
      iOS: {
        bundleId: "com.andiamoplaces.andiamotravelapp",
      },
      android: {
        packageName: "com.andiamoplaces.andiamotravelapp",
        installApp: true,
        minimumVersion: "1.0.0",
      },
      //dynamicLinkDomain: "example.page.link",
    };
    firebase
      .auth()
      .sendSignInLinkToEmail(email, actionCodeSettings)
      .then(() => {
        callback({ pass: true, res: true });
        // ...
      })
      .catch((error) => {
        callback({ pass: false, res: error });
      });
  };

  static Login = (email, password, callback) => {
    // try {
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then((res) => {
        //console.log(res);
        callback({ pass: true, res: res });
      })
      .catch((error) => {
        //console.log(error.message);
        callback({ pass: false, res: error });
      });
  };

  static DeleteAuthUser = (callback) => {
    var user = firebase.auth().currentUser;
    //callback({ pass: false, user: user });
    user.delete().then(
      function () {
        callback({ pass: true, error: "" });
      },
      function (error) {
        console.log(error.message);
        callback({ pass: false, error: error.message });
      }
    );
  };

  static AnonymousLogin = (callback) => {
    firebase
      .auth()
      .signInAnonymously()
      .then((res) => {
        callback({ pass: true, res: res });
      })
      .catch((error) => {
        // var errorCode = error.code;
        // var errorMessage = error.message;
        callback({ pass: false, res: error });
      });
  };

  static Logout = (callback) => {
    firebase
      .auth()
      .signOut()
      .then(
        function () {
          callback({ pass: true, res: true });
        },
        function (error) {
          callback({ pass: false, res: error });
        }
      );
  };

  static forgotPassword = (Email, callback) => {
    firebase
      .auth()
      .sendPasswordResetEmail(Email)
      .then(function (user) {
        //console.log(user);
        callback(true);
      })
      .catch(function (e) {
        console.log("forgotPassword error: ", e);
        callback(e);
      });
  };

  static readSettings = (callback) => {
    //console.log("readSettings", user_id);
    const db = firebase.firestore();
    var docRef = db.collection("settings").doc("settings");
    docRef
      .get()
      .then(function (doc) {
        if (doc.exists) {
          //console.log("Read Settings from FB");
          callback({ pass: true, res: doc.data() });
        } else {
          //console.log("Could not read Settings from FB!");
          callback({ pass: false, res: "No user found" });
        }
      })
      .catch(function (error) {
        console.log("Error getting settings from Firebase:", error.message);
        callback({ pass: false, res: error });
      });
  };

  static readUser = (user_id, callback) => {
    //console.log("readUser", user_id);
    const db = firebase.firestore();
    var docRef = db.collection("users").doc(user_id);
    docRef
      .get()
      .then(async function (doc) {
        if (doc.exists) {
          //console.log("Read user info from FB");
          callback({ pass: true, res: await DataBase._withPrivate(doc.data().uid, doc.data()) });
        } else {
          //console.log("No such user in FB!");
          callback({ pass: false, res: "No user found" });
        }
      })
      .catch(function (error) {
        console.log("Error getting user from Firebase:", error.message);
        callback({ pass: false, res: error });
      });
  };

  // ---- private details (2026-11-01, Common/userPrivacy.js) ----
  // user_private/<uid>: email, travel documents, payment info — readable only by that person (and the admin).
  // null when there is none yet or it can't be read (someone else's).
  static _readPrivate = async (uid) => {
    try {
      const doc = await firebase.firestore().collection("user_private").doc(uid).get();
      return doc.exists ? doc.data() : null;
    } catch (e) {
      return null;
    }
  };

  // Saves the private details and keeps the email index (user_emails/<address> → uid) for "share by email".
  static _savePrivate = async (uid, priv) => {
    if (!uid || !priv || !Object.keys(priv).length) return;
    const db = firebase.firestore();
    await db.collection("user_private").doc(uid).set(priv, { merge: true });
    const key = emailKey(priv.email);
    if (key) await db.collection("user_emails").doc(key).set({ uid }).catch((e) => console.log("email index:", e.message));
  };

  // Own profile: the private record merged in. A profile from before the move still carries its private
  // fields; those are used as they are and copied into the private record (then the next save drops them
  // from the profile).
  static _withPrivate = async (uid, data) => {
    if (!uid || firebase.auth().currentUser?.uid !== uid) return data;
    const priv = await DataBase._readPrivate(uid);
    if (priv) return mergeUser(data, priv);
    const legacy = legacyPrivate(data);
    if (legacy) DataBase._savePrivate(uid, legacy).catch((e) => console.log("moving private details:", e.message));
    return data;
  };

  static findUserByUID = (uid, callback) => {
    //console.log("findUserByUID", uid);
    const db = firebase.firestore();
    db.collection("users")
      .where("uid", "==", uid)
      .get()
      .then(async (querySnapshot) => {
        if (querySnapshot.empty) {
          callback({ pass: false, res: "No user found", doc_id: null });
          // return;
        } else {
          var doc = querySnapshot.docs[0];
          //console.log("findUserByUID doc", doc);
          callback({ pass: true, res: await DataBase._withPrivate(uid, doc.data()), doc_id: doc.id });
          // return;
        }
      })
      .catch(function (error) {
        console.log("Error finding User By UID:", error.message);
        callback({ pass: false, res: error, doc_id: null });
      });
  };

  static findUserByFBID = (fb_id, callback) => {
    //console.log("findUserByFBID", fb_id);
    const db = firebase.firestore();
    db.collection("users")
      .where("fb_id", "==", fb_id)
      .get()
      .then((querySnapshot) => {
        if (querySnapshot.empty) {
          callback({ pass: false, res: "No user found", doc_id: null });
          // return;
        } else {
          var doc = querySnapshot.docs[0];
          //console.log("findUserByFBID doc", doc);
          callback({ pass: true, res: doc.data(), doc_id: doc.id });
          // return;
        }
      })
      .catch(function (error) {
        console.log("Error finding User By FB ID:", error.message);
        callback({ pass: false, res: error, doc_id: null });
      });
  };

  // Tries the lowercase address first (sign-in stores emails lowercase), then
  // the address as typed — see Common/emailLookup.js.
  // 2026-11-01: through the email index (user_emails/<address> → uid; it answers one exact address and can't be
  // listed); the old search on the profiles' email field stays as a fallback until every profile is moved.
  static findUserByEmail = async (email, callback) => {
    const db = firebase.firestore();
    try {
      const key = emailKey(email);
      const idx = key ? await db.collection("user_emails").doc(key).get().catch(() => null) : null;
      if (idx && idx.exists && idx.data().uid) {
        const snap = await db.collection("users").where("uid", "==", idx.data().uid).limit(1).get();
        if (!snap.empty) {
          callback({ pass: true, res: { ...snap.docs[0].data(), email: key }, doc_id: snap.docs[0].id });
          return;
        }
      }
      for (const candidate of emailCandidates(email)) {
        const querySnapshot = await db.collection("users").where("email", "==", candidate).get();
        if (!querySnapshot.empty) {
          const doc = querySnapshot.docs[0];
          callback({ pass: true, res: doc.data(), doc_id: doc.id });
          return;
        }
      }
      callback({ pass: false, res: "No user found", doc_id: null });
    } catch (error) {
      console.log("Error getting user from Firebase:", error.message);
      callback({ pass: false, res: error, doc_id: null });
    }
  };

  static getAllUsers = (callback) => {
    let users = [];
    //console.log("getAllUsers");
    const db = firebase.firestore();
    db.collection("users")
      .get()
      .then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          users.push({ data: doc.data() });
        });
        callback({ pass: true, res: users });
      })
      .catch(function (error) {
        console.log("Error getting users from Firebase:", error.message);
        callback({ pass: false, res: error });
      });
  };

  static updateUser = (_user, user_id, callback) => {
    if (DataBase._isGuest(user_id)) { DataBase._guestBlock(callback); return; }
    //console.log("updateUser", _user);
    // if (user.uid == "guest") {
    //   callback({ pass: true, res: user.uid });
    //   return;
    // }
    if (_user == null || user_id == null) {
      callback({ pass: false, res: "user is null" });
      return;
    }
    // the profile gets only the public fields (and loses any private ones left from before the move);
    // email, travel documents and payment info go to the private record (2026-11-01)
    const { pub: user, priv } = splitUser(JSON.parse(JSON.stringify(_user)));
    user.modify_date = DateTime.utc().toISO();
    // a private field leaves the profile only as it is saved to the private record (never lost on the way)
    Object.keys(priv).forEach((k) => (user[k] = firebase.firestore.FieldValue.delete()));
    var db = firebase.firestore();
    // users docs are keyed by an auto-generated ID, but many callers pass
    // the auth uid instead — .update() on users/<uid> then failed silently
    // (last-guide tracking, Settings, Advanced Mode toggle...). Resolve the
    // real doc by the uid field, same as mobile's updateUser; fall back to
    // the given ID for a user object with no uid. Found 2026-10-07.
    const resolveDocId = user.uid
      ? db.collection("users").where("uid", "==", user.uid).limit(1).get().then((snap) => (snap.empty ? user_id : snap.docs[0].id))
      : Promise.resolve(user_id);
    resolveDocId
      // the private record first, so a field never leaves the profile before it is safe elsewhere
      .then(async (docId) => {
        // if the private record can't be written (no uid, or the rules for it aren't live), the details stay
        // in the profile as before rather than being lost
        const saved = _user.uid ? await DataBase._savePrivate(_user.uid, priv).then(() => true, () => false) : false;
        if (!saved) Object.assign(user, priv);
        await db.collection("users").doc(docId).update(user);
        return docId;
      })
      .then((docId) => {
        callback({ pass: true, res: docId });
      })
      .catch(function (error) {
        console.log("updateUser failed:", error.message);
        callback({ pass: false, res: error });
      });
  };

  static DeleteUser = (user_id, callback) => {
    if (DataBase._isGuest(user_id)) { DataBase._guestBlock(callback); return; }
    if (user_id == null) callback({ pass: false, res: "user is null" });
    var db = firebase.firestore();
    db.collection("users")
      .doc(user_id)
      .delete()
      .then(async () => {
        // the private record and its email index go too (2026-11-01)
        const uid = firebase.auth().currentUser?.uid;
        if (uid) {
          const priv = await DataBase._readPrivate(uid);
          const key = emailKey(priv?.email);
          if (key) await db.collection("user_emails").doc(key).delete().catch(() => {});
          await db.collection("user_private").doc(uid).delete().catch(() => {});
        }
        callback({ pass: true, res: user_id });
      })
      .catch(function (error) {
        callback({ pass: false, res: error });
      });
  };

  static addUser = (_user, callback) => {
    if (DataBase._isGuest(_user?.uid)) { DataBase._guestBlock(callback); return; }
    //console.log("user", _user);
    const { pub: user, priv } = splitUser(JSON.parse(JSON.stringify(_user)));
    user.create_date = DateTime.utc().toISO();
    user.modify_date = DateTime.utc().toISO();

    var db = firebase.firestore();
    db.collection("users")
      .add(user)
      .then(async (docRef) => {
        // no private record possible (the rules for it not live yet): the details stay in the profile as before
        const saved = await DataBase._savePrivate(user.uid, priv).then(() => true, () => false);
        if (!saved && Object.keys(priv).length) await docRef.update(priv).catch(() => {});
        // A new account, with what first brought this browser in.
        logAnalyticsEvent("signup", { uid: user.uid, ...firstTouchFields() });
        callback({ pass: true, res: docRef.id });
      })
      .catch((error) => {
        callback({ pass: false, res: error });
      });
  };

  static getUserImages = (uid, callback) => {
    let images = [];
    const db = firebase.firestore();
    db.collection("images")
      .where("user_id", "==", uid)
      .get()
      .then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          images.push({ id: doc.id, data: doc.data() });
        });
        callback({ pass: true, res: images });
      })
      .catch(function (error) {
        console.log("Error getting user images from Firebase:", error.message);
        callback({ pass: false, res: error });
      });
  };

  static deleteFromStorage = (storageURLs, callback) => {
    if (DataBase._isGuest(firebase.auth().currentUser?.uid)) { DataBase._guestBlock(callback); return; }
    if (storageURLs.length === 0) {
      callback({ pass: true, error: "" });
      return;
    }
    let error_flag = false;
    for (let i = 0; i < storageURLs.length && !error_flag; i++) {
      var desertRef = firebase.storage().refFromURL(storageURLs[i]);
      desertRef
        .delete()
        .then(function () {
          if (i === storageURLs.length - 1) callback({ pass: true, error: "" });
        })
        .catch(function (error) {
          //console.log("Error deleting image", error.message);
          //Alert.alert("Error Cancelling Account, check internet and try again");
          error_flag = true;
          callback({ pass: false, error: error });
          return;
        });
    }
  };

  static addImage = async (image_meta, callback) => {
    if (DataBase._isGuest(image_meta?.user_id)) { DataBase._guestBlock(callback); return; }
    var db = firebase.firestore();
    db.collection("images")
      .add(image_meta)
      .then((docRef) => {
        callback({ pass: true, res: docRef.id });
      })
      .catch((error) => {
        console.log("Error adding user image to Firebase:", error.message);
        callback({ pass: false, res: error });
      });
  };

  static updateImage = async (image_id, image_meta, callback) => {
    if (DataBase._isGuest(firebase.auth().currentUser?.uid)) { DataBase._guestBlock(callback); return; }
    var db = firebase.firestore();
    await db
      .collection("images")
      .doc(image_id)
      .update(image_meta)
      .then(() => {
        if (callback !== null) callback({ pass: true, image_id: image_id, image_meta: image_meta });
      })
      .catch(function (error) {
        console.log("Error updating user image in Firebase:", error.message);
        if (callback !== null) callback({ pass: false, res: error });
      });
  };

  static deleteImage = async (image_id, callback) => {
    if (DataBase._isGuest(firebase.auth().currentUser?.uid)) { DataBase._guestBlock(callback); return; }
    const db = firebase.firestore();
    await db
      .collection("images")
      .doc(image_id)
      .delete()
      .then(function () {
        //console.log("*** call cleanup***", callback);
        if (callback !== null) callback({ pass: true, res: image_id });
      })
      .catch(function (error) {
        console.error("Error deleting Image from Firebase: ", error.message);
        if (callback !== null) callback({ pass: false, res: error });
      });
  };

  static getAttachments = (context, uid, callback) => {
    let attachments = [];
    const db = firebase.firestore();
    db.collection("attachments")
      .where("user_id", "==", uid)
      .where("context", "==", context)
      .get()
      .then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          attachments.push({ id: doc.id, data: doc.data() });
        });
        callback({ pass: true, res: attachments });
      })
      .catch(function (error) {
        console.log("Error getting attachments from Firebase:", error.message);
        callback({ pass: false, res: error });
      });
  };

  static addAttachment = async (attachment_meta, callback) => {
    if (DataBase._isGuest(attachment_meta?.user_id)) { DataBase._guestBlock(callback); return; }
    var db = firebase.firestore();
    db.collection("attachments")
      .add(attachment_meta)
      .then((docRef) => {
        callback({ pass: true, res: docRef.id });
      })
      .catch((error) => {
        console.log("Error adding attachment to Firebase:", error.message);
        callback({ pass: false, res: error });
      });
  };

  static deleteAttachment = async (attachment_id, callback) => {
    if (DataBase._isGuest(firebase.auth().currentUser?.uid)) { DataBase._guestBlock(callback); return; }
    const db = firebase.firestore();
    await db
      .collection("attachments")
      .doc(attachment_id)
      .delete()
      .then(function () {
        if (callback !== null) callback({ pass: true, res: attachment_id });
      })
      .catch(function (error) {
        console.error("Error deleting attachment from Firebase: ", error.message);
        if (callback !== null) callback({ pass: false, res: error });
      });
  };

  static deleteImageMeta = (ids, callback) => {
    if (DataBase._isGuest(firebase.auth().currentUser?.uid)) { DataBase._guestBlock(callback); return; }
    if (ids.length === 0) {
      callback({ pass: true, error: "" });
      return;
    }
    let error_flag = false;
    const db = firebase.firestore();
    for (let i = 0; i < ids.length && !error_flag; i++) {
      db.collection("images")
        .doc(ids[i])
        .delete()
        .then(function () {
          if (i === ids.length - 1) callback({ pass: true, error: "" });
        })
        .catch(function (error) {
          error_flag = true;
          callback({ pass: false, error: error });
          return;
        });
    }
  };

  deleteFileFromStorage = (file_name, callback1, callback2) => {
    const storageRef = firebase.storage().ref();
    var desertRef = firebase.storage().refFromURL(this._selected_file.url);
    desertRef
      .delete()
      .then(function () {
        callback1(file_name, callback2);
      })
      .catch(function (error) {
        console.log("Error deleting storage file", error.message);
        callback1(null, null);
      });
  };

  static updateGuideData = (guide_data, guide_data_id, uid, callback) => {
    if (DataBase._isGuest(uid)) { DataBase._guestBlock(callback); return; }
    //console.log("updateGuideData", guide_data_id, uid, callback);
    const _data = {
      data: JSON.stringify(guide_data, Place.storageReplacer),
      user_id: uid,
    };
    if (!DataBase._sizeGate(_data.data, callback)) return;
    //console.log("updateGuideData", _data);
    var db = firebase.firestore();
    // var col = db.collection("guide_data").doc(guide_data_id);
    // //console.log(col);
    // return;
    db.collection("guide_data")
      .doc(guide_data_id)
      .set(_data)
      .then(() => {
        callback({ pass: true, res: true });
      })
      .catch(function (error) {
        console.log("Error updating guide data", error.message);
        callback({ pass: false, res: error });
      });
  };

  static updateGuideInfo = (guide_id, guide_info, guide_info_id, user_id, callback) => {
    if (DataBase._isGuest(user_id)) { DataBase._guestBlock(callback); return; }
    guide_info.user_id = user_id;
    guide_info.guide_id = guide_id;
    guide_info.mod = DateTime.utc().toISO();

    delete guide_info.start_date;
    delete guide_info.end_date;
    delete guide_info.ratings;
    delete guide_info.price;
    delete guide_info.shared;
    delete guide_info.group_read;
    delete guide_info.group_copy;
    delete guide_info.group_modify;
    delete guide_info.categories;

    var db = firebase.firestore();
    db.collection("guide_info")
      .doc(guide_info_id)
      .update(guide_info)
      .then(() => {
        callback({ pass: true, res: true });
      })
      .catch(function (error) {
        callback({ pass: false, res: error });
      });
  };

  // Edit Guide Info's OK writes its own fields straight to the guide's
  // library entry (2026-10-24), so sharing takes effect at once instead of
  // only with the next full guide save. Deliberately leaves `mod` alone (a
  // new mod would read as someone else's save in the next save's conflict
  // check) and `rating` (reviews own it).
  static GUIDE_INFO_EDIT_FIELDS = ["guide_name", "description", "image", "image_m", "language", "countries", "cities", "access", "type"];
  static updateGuideInfoFields = async (guide_info_id, attributes) => {
    if (guide_info_id == null) return false;
    const fields = {};
    DataBase.GUIDE_INFO_EDIT_FIELDS.forEach((k) => {
      if (attributes[k] !== undefined) fields[k] = attributes[k];
    });
    try {
      await firebase.firestore().collection("guide_info").doc(guide_info_id).update(fields);
      return true;
    } catch (e) {
      console.log("updateGuideInfoFields", e.message);
      return false;
    }
  };

  static addGuideInfo = (guide_info, guide_id, user_info, callback) => {
    if (DataBase._isGuest(user_info?.uid)) { DataBase._guestBlock(callback); return; }
    guide_info.user_id = user_info.uid;
    guide_info.owner_name = `${user_info.first_name} ${user_info.last_name}`;
    guide_info.guide_id = guide_id;
    guide_info.mod = DateTime.utc().toISO();
    guide_info.num_ratings = 0;

    // delete guide_info.start_date;
    // delete guide_info.end_date;
    // delete guide_info.ratings;
    // delete guide_info.price;
    // delete guide_info.shared;
    // delete guide_info.group_read;
    // delete guide_info.group_copy;
    // delete guide_info.group_modify;
    // delete guide_info.categories;

    //console.log("addGuideInfo", guide_info);
    //console.log("_info", _info);
    var db = firebase.firestore();
    db.collection("guide_info")
      .add({ ...guide_info })
      .then((docRef) => {
        callback({ pass: true, res: docRef.id });
      })
      .catch((error) => {
        callback({ pass: false, res: error });
      });
  };

  static copyGuideInfo = (guide_info, guide_id, user_info, callback) => {
    if (DataBase._isGuest(user_info?.uid)) { DataBase._guestBlock(callback); return; }
    guide_info.access = [user_info.uid];
    guide_info.guide_name = guide_info.guide_name + "_C";
    this.addGuideInfo(guide_info, guide_id, user_info, callback);
  };

  static addGuideData = (guide_data, callback) => {
    if (DataBase._isGuest(guide_data?.user_id)) { DataBase._guestBlock(callback); return; }
    //console.log("guide_data", guide_data);
    const _data = {
      data: JSON.stringify(guide_data, Place.storageReplacer),
      user_id: guide_data.user_id,
    };
    if (!DataBase._sizeGate(_data.data, callback)) return;
    var db = firebase.firestore();
    db.collection("guide_data")
      .add(_data)
      .then((docRef) => {
        callback({ pass: true, res: docRef.id });
      })
      .catch((error) => {
        callback({ pass: false, res: error });
      });
  };

  static batchedWriteGuide = (
    _guide_data,
    _guide_id,
    _guide_info_id,
    user_info,
    type,
    callback,
    to_guide_id,
    to_guide_info_id,
    keepOriginalName,
    expectedMod
  ) => {
    if (DataBase._isGuest(user_info?.uid)) { DataBase._guestBlock(callback); return; }
    //console.log("batchedWriteGuide", guide_id, guide_info_id, user_info, type);
    var guide_data = JSON.parse(JSON.stringify(_guide_data));
    var guide_id = JSON.parse(JSON.stringify(_guide_id));
    var guide_info_id = JSON.parse(JSON.stringify(_guide_info_id));
    if (to_guide_id != null && to_guide_info_id != null && type == "overwrite") {
      guide_id = to_guide_id;
      guide_info_id = to_guide_info_id;
    }
    var guide_info = guide_data.attributes;
    // Wanderlist summary for this guide, on its guide_info doc (2026-10-23,
    // see Common/wanderlistSummary.js). Never allowed to stop a save.
    try { guide_info.wanderlist = buildGuideSummary(guide_data); } catch (e) { console.log("wanderlist summary", e?.message); }
    console.log("guide_info access:", guide_info.access);
    console.log("guide_info type:", guide_info.type);
    if (type === "new") {
      guide_data.creator_id = user_info.uid;
      guide_info.creator_id = user_info.uid;
    }

    //console.log("batchedWriteGuide 1");
    // Prepare batch
    var db = firebase.firestore();
    var batch = db.batch();

    // Created early (identity only depends on type/guide_info_id, not on
    // the guide_info payload mutations below) so its id is available when
    // building guide_data's own payload just below — Firestore refs are
    // free to create; nothing is written until batch.set/update is called
    // on it further down. Requested 2026-09-28 — see project memory:
    // project_new_guide_in_memory_fix (Firestore rules Phase 2).
    var guide_info_ref =
      type === "modify" || type === "overwrite"
        ? db.collection("guide_info").doc(guide_info_id)
        : db.collection("guide_info").doc();

    const _data = {
      data: JSON.stringify(guide_data, Place.storageReplacer),
    };
    // Denormalized onto guide_data so a Firestore security rule can check
    // access without a reverse query: guide_info_id lets it get() the
    // parent guide_info doc (for a non-owner/shared access check), and
    // user_id lets it skip that extra read entirely for the common case —
    // the owner accessing their own guide. Requested 2026-09-28.
    //
    // new/copy: use user_info.uid directly (the creator/copier always
    // becomes the new owner) rather than guide_info.user_id — a guide
    // created via createLocalGuide's in-memory path never has user_id set
    // at all until promotion, so reading it here (before it's corrected to
    // user_info.uid below) could write undefined. Matches exactly what
    // guide_info.user_id itself gets set to a few lines down.
    if (type === "new" || type === "copy") {
      _data.user_id = user_info.uid;
      _data.guide_info_id = guide_info_ref.id;
    } else if (type === "modify") {
      // Preserve the EXISTING owner (from the already-loaded guide state) —
      // the editor might be a MODIFY-level sharee, not the owner.
      if (guide_info.user_id) _data.user_id = guide_info.user_id;
      _data.guide_info_id = guide_info_ref.id;
    }
    // "overwrite" deliberately left untouched: the target guide_data doc's
    // true owner isn't available here (guide_info.user_id gets deleted from
    // the payload for this type, a few lines down, specifically so this
    // write doesn't clobber the target's real ownership) — whatever
    // user_id/guide_info_id the target doc already has stays as-is.

    const size = DataBase._sizeGate(_data.data, callback);
    if (!size) return;
    const sizeWarning = size.level === "warn" ? size.message : "";

    var guide_data_ref = null;
    let guide_id_to_log = "";
    const isModifyOrOverwrite = type === "modify" || type === "overwrite";
    if (isModifyOrOverwrite) {
      guide_data_ref = db.collection("guide_data").doc(guide_id);
      guide_id_to_log = guide_id;
    } else {
      guide_data_ref = db.collection("guide_data").doc();
      guide_id_to_log = guide_data_ref.id;
    }
    // Registering guide_data_ref's write (batch.update/set vs transaction.update)
    // is deferred to the conflict-check branch below, since the modify+expectedMod
    // path needs to decide between a plain batch and a runTransaction. _data itself
    // is already fully computed here (JSON.stringify'd above) so deferring WHEN it's
    // registered doesn't change WHAT gets written.

    //console.log("batchedWriteGuide 2");
    guide_info.mod = DateTime.utc().toISO();
    // Stamped alongside mod so the conflict dialog can say who last changed the
    // guide; mod itself (not this field) is what the conflict check compares.
    guide_info.last_modified_by = user_info.uid;
    if (type === "copy" && !keepOriginalName) guide_info.guide_name = guide_info.guide_name + "_C";
    if (type === "copy" || type === "new") {
      //guide_data.user_id = user_info.uid;
      guide_info.user_id = user_info.uid;
      guide_info.owner_name = `${user_info.first_name} ${user_info.last_name}`;
      guide_info.guide_id = guide_data_ref.id;
      guide_info.access = [user_info.uid];
      guide_info.created = guide_info.mod;
      guide_info.read = guide_info.mod;
      guide_info.copy = guide_info.mod;
      guide_info.rating = 0;
      guide_info.num_ratings = 0;
      guide_info.times_read = 0;
      guide_info.times_copied = 0;
      guide_info.type = "";
    }
    if (type !== "copy" && type !== "new") {
      delete guide_info.rating;
      delete guide_info.created;
      delete guide_info.read;
      delete guide_info.copy;
      delete guide_info.num_ratings;
      delete guide_info.times_read;
      delete guide_info.times_copied;
    }
    if (type === "overwrite") {
      delete guide_info.access;
      delete guide_info.guide_id;
      delete guide_info.owner_name;
      delete guide_info.user_id;
    }

    // A Featured guide is meant for everyone to use and copy — "Featured"
    // (type) only lists it on the Featured tab; access comes from this list.
    // If it has no community grant, add "Copy for all users" (All_C) so
    // featuring can't leave it uncopyable (40 of 437 Featured guides were,
    // incl. Paris/London/Prague — fixed 2026-10-09 by
    // scripts/addCopyAccessToFeatured.js). An existing All_R/All_C/All_M is
    // left as the owner set it.
    if (
      guide_info.type === "Featured" &&
      Array.isArray(guide_info.access) &&
      !guide_info.access.some((a) => typeof a === "string" && a.startsWith("All_"))
    ) {
      guide_info.access = [...guide_info.access, "All_C"];
    }
    //guide_info.locked_until = DateTime.utc().toISO();

    delete guide_info.categories;
    delete guide_info.start_date;
    delete guide_info.end_date;
    delete guide_info.ratings;
    delete guide_info.price;
    delete guide_info.shared;
    delete guide_info.group_read;
    delete guide_info.group_copy;
    delete guide_info.group_modify;

    //console.log("guide_info end:", guide_info);

    ReactGA.event({
      category: "Guide Access",
      action: `Guide ${type}`,
      label: guide_id_to_log,
    });
    logAnalyticsEvent("guide_write", {
      uid: user_info.uid,
      guide_id: guide_id_to_log,
      action: type,
      // Which guide a copy was made from (see logGuideView).
      ...(type === "copy" && lastOpenedGuideInfoId ? { source: lastOpenedGuideInfoId } : {}),
    });

    // Conflict-safe path: "modify" writes to an existing shared guide check
    // the server's current guide_info.mod against the caller's last-known
    // value inside a transaction before writing anything. "new"/"copy" have
    // no prior doc to conflict with; "overwrite" has its own freshness
    // re-check upstream (readGuideTransaction before this is called) and is
    // left on the plain-batch path below.
    if (type === "modify" && expectedMod != null) {
      db.runTransaction((transaction) => {
        return transaction.get(guide_info_ref).then((infoDoc) => {
          if (!infoDoc.exists) throw new Error("Guide info not found");
          // Compare by instant, not raw string — two ISO strings can
          // represent the exact same moment in different valid formats
          // (e.g. "...-07:00" vs "...Z"), depending on which code path wrote
          // mod last. A strict string compare treats those as different and
          // falsely conflicts even when nothing actually changed. Diagnosed
          // 2026-10-01 via a temporary debug log that caught exactly this.
          const serverMs = DateTime.fromISO(infoDoc.data().mod).toMillis();
          const expectedMs = DateTime.fromISO(expectedMod).toMillis();
          if (serverMs !== expectedMs) {
            const conflictError = new Error("CONFLICT");
            conflictError.code = "CONFLICT";
            conflictError.serverGuideInfo = infoDoc.data();
            throw conflictError;
          }
          transaction.update(guide_data_ref, _data);
          transaction.update(guide_info_ref, { ...guide_info });
        });
      })
        .then(() => {
          callback({ pass: true, new_doc_ref: guide_data_ref, new_info_ref: guide_info_ref, new_mod: guide_info.mod, sizeWarning });
        })
        .catch((error) => {
          console.log("batchedWriteGuide error", error.message);
          if (error.code === "CONFLICT") {
            callback({
              pass: false,
              conflict: true,
              serverGuideInfo: error.serverGuideInfo,
              new_doc_ref: null,
              new_info_ref: null,
              error: error,
            });
          } else {
            callback({ pass: false, new_doc_ref: null, new_info_ref: null, error: error });
          }
        });
      return;
    }

    // guide_info_ref itself was already created above (before guide_data's
    // payload was built) — just write to it here now that guide_info's
    // content is finalized.
    if (isModifyOrOverwrite) {
      batch.update(guide_data_ref, _data);
      batch.update(guide_info_ref, { ...guide_info });
    } else {
      batch.set(guide_data_ref, _data);
      batch.set(guide_info_ref, { ...guide_info });
    }
    //console.log("batchedWriteGuide 4");
    // Commit the batch
    batch
      .commit()
      .then(() => {
        console.log("batchedWriteGuide 5");
        callback({ pass: true, new_doc_ref: guide_data_ref, new_info_ref: guide_info_ref, new_mod: guide_info.mod, sizeWarning });
      })
      .catch((error) => {
        console.log("batchedWriteGuide error", error.message);
        callback({ pass: false, new_doc_ref: null, new_info_ref: null, error: error });
      });
  };

  // Gives a local-only guide (never written to Firestore, e.g. a guest's in-memory
  // AI-generated trip, or a guide loaded from a device-only file) a real cloud home.
  // Single write: batchedWriteGuide's "new" path serializes whatever GuideObj it's
  // given, populated or not, so there's no separate "create empty then copy" step.
  static persistLocalGuide = (GuideObj, user_info, callback) => {
    GuideObj.user_id = user_info.uid;
    DataBase.batchedWriteGuide(GuideObj, null, null, user_info, "new", (res) => {
      if (res.pass !== true) {
        callback(res);
        return;
      }
      DataBase.readGuideTransaction(res.new_info_ref.id, callback, user_info.uid);
    });
  };

  static batchedUpdateGuide = (guide_data, guide_id, guide_info_id, user_info, type, callback) => {
    if (DataBase._isGuest(user_info?.uid)) { DataBase._guestBlock(callback); return; }
    // Get a new write batch
    var guide_info = guide_data.attributes;
    // Wanderlist summary for this guide, on its guide_info doc (2026-10-23,
    // see Common/wanderlistSummary.js). Never allowed to stop a save.
    try { guide_info.wanderlist = buildGuideSummary(guide_data); } catch (e) { console.log("wanderlist summary", e?.message); }
    //console.log("guide_info start:", guide_info);
    guide_data.user_id = user_info.uid;
    const _data = {
      data: JSON.stringify(guide_data, Place.storageReplacer),
      user_id: user_info.uid,
    };
    const size = DataBase._sizeGate(_data.data, callback);
    if (!size) return;

    // Prepare batch
    var db = firebase.firestore();
    var batch = db.batch();
    var addd_guide_data_ref = db.collection("guide_data").doc();
    if (type === "modify") addd_guide_data_ref = db.collection("guide_data").doc(guide_id);
    //console.log("addd_guide_data_ref.id", addd_guide_data_ref.id);
    // Add Write the guide_data to batch
    batch.set(addd_guide_data_ref, _data);

    // write the guide_info
    guide_info.user_id = user_info.uid;
    guide_info.owner_name = `${user_info.first_name} ${user_info.last_name}`;
    guide_info.guide_id = addd_guide_data_ref.id;
    guide_info.mod = DateTime.utc().toISO();
    if (type === "copy") guide_info.guide_name = guide_info.guide_name + "_C";
    if (type !== "modify") {
      guide_info.created = guide_info.mod;
      guide_info.read = guide_info.mod;
      guide_info.copy = guide_info.mod;
      guide_info.num_ratings = 0;
      guide_info.times_read = 0;
      guide_info.times_copied = 0;
    }
    // else {
    //   guide_info.access = [user_info.uid];
    // }
    //guide_info.locked_until = DateTime.utc().toISO();

    delete guide_info.categories;
    delete guide_info.start_date;
    delete guide_info.end_date;
    delete guide_info.ratings;
    delete guide_info.price;
    delete guide_info.shared;
    delete guide_info.group_read;
    delete guide_info.group_copy;
    delete guide_info.group_modify;
    delete guide_info.categories;
    //console.log("guide_info end:", guide_info);

    //batch.set(db.collection('col').doc(), doc);
    var addd_guide_info_ref = db.collection("guide_info").doc();
    if (type == "modify") addd_guide_info_ref = db.collection("guide_info").doc(guide_info_id);
    //console.log("addd_guide_info_ref", addd_guide_info_ref.id);
    batch.set(addd_guide_info_ref, { ...guide_info });

    // Commit the batch
    batch
      .commit()
      .then(() => {
        callback({ pass: true, new_doc_ref: addd_guide_data_ref, new_info_ref: addd_guide_info_ref, sizeWarning: size.level === "warn" ? size.message : "" });
      })
      .catch((error) => {
        callback({ pass: false, new_doc_ref: null, new_info_ref: null, error: error });
      });
  };

  static copyGuideData = (guide_data, user_id, callback) => {
    if (DataBase._isGuest(user_id)) { DataBase._guestBlock(callback); return; }
    guide_data.user_id = user_id;
    this.addGuideData(guide_data, callback);
  };

  static readGuideInfo = (guide_info_id, callback) => {
    //console.log("readGuideInfo", guide_info_id);
    const db = firebase.firestore();
    var docRef = db.collection("guide_info").doc(guide_info_id);
    docRef
      .get()
      .then(function (doc) {
        if (doc.exists) {
          //console.log("Read guide info from FB");
          callback({ pass: true, res: doc.data() });
        } else {
          //console.log("No such guide info in FB!");
          callback({ pass: false, res: "No guide info found" });
        }
      })
      .catch(function (error) {
        console.log("Error getting guide info from Firebase:", error.message);
        callback({ pass: false, res: error });
      });
  };

  // One-time Wanderlist summary for a guide saved before summaries existed
  // (2026-10-23, matches mobile): reads the guide, builds its summary and
  // stores only that field on its guide_info doc (owner only, per the rules).
  // Nothing else about the guide changes — not even its modified date.
  static fillGuideWanderlist = async (guide_info_id, guide_id) => {
    try {
      const db = firebase.firestore();
      const snap = await db.collection("guide_data").doc(guide_id).get();
      if (!snap.exists) return null;
      const raw = snap.data()?.data;
      const guide = typeof raw === "string" ? JSON.parse(raw) : raw;
      const summary = buildGuideSummary(guide);
      await db.collection("guide_info").doc(guide_info_id).update({ wanderlist: summary });
      return summary;
    } catch (e) {
      console.log("fillGuideWanderlist", guide_info_id, e?.message);
      return null;
    }
  };

  static readGuideData = (guide_id, callback) => {
    //console.log("readGuideData", guide_id);
    const db = firebase.firestore();
    var docRef = db.collection("guide_data").doc(guide_id);
    docRef
      .get()
      .then(function (doc) {
        if (doc.exists) {
          //console.log("Guide Downloaded from FB");
          callback({ pass: true, guide_id: guide_id, res: doc.data() });
        } else {
          //console.log("No such guide in FB!");
          callback({ pass: false, res: "No Guide found" });
        }
      })
      .catch(function (error) {
        console.log("Error getting guide from Firebase:", error.message);
        callback({ pass: false, res: error });
      });
  };

  static xxxgetAllGuideInfo = (user_id, callback) => {
    if (user_id == null) user_id = "XXXXXXXXXXX";

    let search_field = "access";
    let compare_op = "array-contains-any";
    let access_array = [user_id, `${user_id}:R`, `${user_id}:C`, `${user_id}:M`, "All_R", "All_C", "All_M"];

    let search_field2 = "type";
    let compare_op2 = "!=";
    let access_array2 = "Featured";

    //console.log("access_array", access_array);
    let guides = [];
    const db = firebase.firestore();
    db.collection("guide_info")
      .where(search_field, compare_op, access_array)
      //.where(search_field2, compare_op2, access_array2)
      .get()
      .then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          // doc.data() is never undefined for query doc snapshots
          guides.push({ id: doc.id, data: doc.data() });
        });
        guides.forEach((guide_info) => {
          if (typeof guide_info.data.mod == "undefined") guide_info.data.mod = DateTime.utc().toISO();
          if (typeof guide_info.data.created == "undefined") guide_info.data.created = guide_info.mod;
          if (typeof guide_info.data.read == "undefined") guide_info.data.read = guide_info.mod;
          if (typeof guide_info.data.copy == "undefined") guide_info.data.copy = guide_info.mod;
          if (typeof guide_info.data.rating == "undefined") guide_info.data.rating = 0;
          if (isNaN(guide_info.data.rating)) guide_info.data.rating = 0;
          if (typeof guide_info.data.num_ratings == "undefined") guide_info.data.num_ratings = 0;
          if (isNaN(guide_info.data.num_ratings)) guide_info.data.num_ratings = 0;
          if (typeof guide_info.data.times_copied == "undefined") guide_info.data.times_copied = 0;
          if (isNaN(guide_info.data.times_copied)) guide_info.data.times_copied = 0;
          if (typeof guide_info.data.times_read == "undefined") guide_info.data.times_read = 0;
          if (isNaN(guide_info.data.times_read)) guide_info.data.times_read = 0;
        });
        callback({ pass: true, res: guides });
      })
      .catch(function (error) {
        console.log("Error getting all guide infos from Firebase:", error.message);
        callback({ pass: false, res: error });
      });
  };

  // ── Share invitations (4.10.55, 2026-10-26) — see Common/shareInvites.js.
  // user_sharing/{uid} is the person's own private record. Until the Phase 3
  // rules are published these calls fail (permission denied) and callers
  // fall back to today's behaviour (every shared guide shown, no invitations).
  static getSharingState = (uid, callback) => {
    if (!uid || uid === "guest") return callback({ pass: false, res: "No user" });
    firebase.firestore().collection("user_sharing").doc(uid).get()
      .then((doc) => callback({ pass: true, res: doc.exists ? doc.data() : null }))
      .catch((error) => callback({ pass: false, res: error }));
  };

  // guide_info docs by id ([{ id, data }]; missing or unreadable ones left out) — the hidden Featured guides
  // in Library → Shared → "Declined and blocked" (2026-11-01).
  static getGuideInfosByIds = async (ids) => {
    const docs = await Promise.all(
      (ids || []).map((id) => firebase.firestore().collection("guide_info").doc(id).get().catch(() => null))
    );
    return docs.filter((d) => d && d.exists).map((d) => ({ id: d.id, data: d.data() }));
  };

  static setSharingState = (uid, state, callback) => {
    firebase.firestore().collection("user_sharing").doc(uid).set(state)
      .then(() => callback && callback({ pass: true }))
      .catch((error) => callback && callback({ pass: false, res: error }));
  };

  // action: "accept" | "hide" (decline, remove, report) | "restore" (undo a
  // hide: an invitation again) | "block" | "unblock";
  // id: a guide_info id, or for block/unblock the owner's uid.
  static sharingAction = (uid, action, id, callback) => {
    const FV = firebase.firestore.FieldValue;
    const change =
      action === "accept" ? { accepted: FV.arrayUnion(id), hidden: FV.arrayRemove(id) }
      : action === "hide" ? { hidden: FV.arrayUnion(id), accepted: FV.arrayRemove(id) }
      : action === "restore" ? { hidden: FV.arrayRemove(id) }
      : action === "block" ? { blocked: FV.arrayUnion(id) }
      : { blocked: FV.arrayRemove(id) };
    firebase.firestore().collection("user_sharing").doc(uid).set(change, { merge: true })
      .then(() => callback && callback({ pass: true }))
      .catch((error) => callback && callback({ pass: false, res: error }));
  };

  // "Report this guide": filed in the reporter's name; only the admin reads
  // reports (Admin Dashboard). One per person per guide (Common/shareInvites.js
  // reportDocId): a second one is refused by the rules — res.already is then
  // true (a refusal can't be told apart from other permission errors, so it
  // reads "you may have reported it already").
  static addGuideReport = (report, callback) => {
    const fields = reportFields(report);
    firebase.firestore().collection("guide_reports").doc(reportDocId(fields.guide_info_id, fields.reporter_uid))
      .set({ ...fields, status: "open", created: DateTime.utc().toISO() })
      .then(() => callback && callback({ pass: true, res: reportDocId(fields.guide_info_id, fields.reporter_uid) }))
      .catch((error) => callback && callback({ pass: false, res: error, already: error?.code === "permission-denied" }));
  };

  static getGuideReports = (callback) => {
    firebase.firestore().collection("guide_reports").orderBy("created", "desc").limit(200).get()
      .then((snap) => {
        const reports = [];
        snap.forEach((doc) => reports.push({ id: doc.id, ...doc.data() }));
        callback({ pass: true, res: reports });
      })
      .catch((error) => callback({ pass: false, res: error }));
  };

  static updateGuideReport = (id, fields, callback) => {
    firebase.firestore().collection("guide_reports").doc(id).update(fields)
      .then(() => callback && callback({ pass: true }))
      .catch((error) => callback && callback({ pass: false, res: error }));
  };

  static getAllGuideInfo = (user_id, callback, type) => {
    if (user_id == null) user_id = "XXXXXXXXXXX";

    // let compare_op2 = "!=";
    // let search_field2 = "type";
    // let access_array2 = "Featured";

    let compare_op = "array-contains-any";
    let search_field = "access";
    let access_array = [user_id, `${user_id}:R`, `${user_id}:C`, `${user_id}:M`, "All_R", "All_C", "All_M"];
    if (type === "Featured") {
      compare_op = "==";
      access_array = "Featured";
      search_field = "type";
    }
    if (type === "Shared") {
      compare_op = "array-contains-any";
      search_field = "access";
      // Shared means "shared with me by name" (2026-10-26): "All users can …"
      // guides are no longer mixed in (sharing with everyone is admin-only,
      // and those guides are Featured or opened by link).
      access_array = [`${user_id}:R`, `${user_id}:C`, `${user_id}:M`];
    }
    if (type === "Mine") {
      // Mobile app may write access as "uid:M" rather than bare "uid", so run
      // a second query on user_id and merge to catch guides created on mobile.
      const db2 = firebase.firestore();
      const normalize = (guides) => {
        guides.forEach((guide_info) => {
          if (typeof guide_info.data.mod == "undefined") guide_info.data.mod = DateTime.utc().toISO();
          if (typeof guide_info.data.created == "undefined") guide_info.data.created = guide_info.mod;
          if (typeof guide_info.data.read == "undefined") guide_info.data.read = guide_info.mod;
          if (typeof guide_info.data.copy == "undefined") guide_info.data.copy = guide_info.mod;
          if (typeof guide_info.data.rating == "undefined") guide_info.data.rating = 0;
          if (isNaN(guide_info.data.rating)) guide_info.data.rating = 0;
          if (typeof guide_info.data.num_ratings == "undefined") guide_info.data.num_ratings = 0;
          if (isNaN(guide_info.data.num_ratings)) guide_info.data.num_ratings = 0;
          if (typeof guide_info.data.times_copied == "undefined") guide_info.data.times_copied = 0;
          if (isNaN(guide_info.data.times_copied)) guide_info.data.times_copied = 0;
          if (typeof guide_info.data.times_read == "undefined") guide_info.data.times_read = 0;
          if (isNaN(guide_info.data.times_read)) guide_info.data.times_read = 0;
          // GuideDownload/GuideDownloadComponent's search filter calls
          // .toUpperCase() on these unguarded — a guide missing any of them
          // (this "Mine" merge is the one bucket that pulls in mobile-authored
          // docs, which don't always carry the same field shape) threw and
          // aborted the whole filter pass, so typing into the library search
          // box silently stopped updating the guide list. Found 2026-09-18.
          if (typeof guide_info.data.guide_name !== "string") guide_info.data.guide_name = "";
          if (typeof guide_info.data.description !== "string") guide_info.data.description = "";
          if (typeof guide_info.data.owner_name !== "string") guide_info.data.owner_name = "";
          if (typeof guide_info.data.guide_id !== "string") guide_info.data.guide_id = "";
          if (typeof guide_info.data.user_id !== "string") guide_info.data.user_id = "";
        });
        return guides;
      };
      Promise.all([
        db2.collection("guide_info").where("access", "array-contains", user_id).limit(5000).get(),
        db2.collection("guide_info").where("user_id", "==", user_id).limit(5000).get(),
      ])
        .then(([snap1, snap2]) => {
          const seen = new Set();
          const merged = [];
          [snap1, snap2].forEach(snap => {
            snap.forEach(doc => {
              if (!seen.has(doc.id)) { seen.add(doc.id); merged.push({ id: doc.id, data: doc.data() }); }
            });
          });
          callback({ pass: true, res: normalize(merged) });
        })
        .catch(function (error) {
          console.log("Error getting My Guides from Firebase:", error.message);
          callback({ pass: false, res: error });
        });
      return;
    }

    //console.log("access_array", access_array);
    let guides = [];
    const db = firebase.firestore();
    db.collection("guide_info")
      //.where(search_field2, compare_op2, access_array2)
      .where(search_field, compare_op, access_array)
      .limit(5000)
      //.where("user_id", "==", user_id)
      //.where("share_all", "in", ["Read", "Copy", "Modify"])
      .get()
      .then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          // doc.data() is never undefined for query doc snapshots
          guides.push({ id: doc.id, data: doc.data() });
        });
        guides.forEach((guide_info) => {
          if (typeof guide_info.data.mod == "undefined") guide_info.data.mod = DateTime.utc().toISO();
          if (typeof guide_info.data.created == "undefined") guide_info.data.created = guide_info.mod;
          if (typeof guide_info.data.read == "undefined") guide_info.data.read = guide_info.mod;
          if (typeof guide_info.data.copy == "undefined") guide_info.data.copy = guide_info.mod;
          if (typeof guide_info.data.rating == "undefined") guide_info.data.rating = 0;
          if (isNaN(guide_info.data.rating)) guide_info.data.rating = 0;
          if (typeof guide_info.data.num_ratings == "undefined") guide_info.data.num_ratings = 0;
          if (isNaN(guide_info.data.num_ratings)) guide_info.data.num_ratings = 0;
          if (typeof guide_info.data.times_copied == "undefined") guide_info.data.times_copied = 0;
          if (isNaN(guide_info.data.times_copied)) guide_info.data.times_copied = 0;
          if (typeof guide_info.data.times_read == "undefined") guide_info.data.times_read = 0;
          if (isNaN(guide_info.data.times_read)) guide_info.data.times_read = 0;
          // See the matching comment in the "Mine" branch above.
          if (typeof guide_info.data.guide_name !== "string") guide_info.data.guide_name = "";
          if (typeof guide_info.data.description !== "string") guide_info.data.description = "";
          if (typeof guide_info.data.owner_name !== "string") guide_info.data.owner_name = "";
          if (typeof guide_info.data.guide_id !== "string") guide_info.data.guide_id = "";
          if (typeof guide_info.data.user_id !== "string") guide_info.data.user_id = "";
        });
        callback({ pass: true, res: guides });
      })
      .catch(function (error) {
        console.log("Error getting all guide infos from Firebase:", error.message);
        callback({ pass: false, res: error });
      });
  };

  static deleteGuideData = (guide_id, callback) => {
    if (DataBase._isGuest(firebase.auth().currentUser?.uid)) { DataBase._guestBlock(callback); return; }
    const db = firebase.firestore();
    db.collection("guide_data")
      .doc(guide_id)
      .delete()
      .then(function () {
        //console.log("Guide data successfully deleted!");
        callback({ pass: true, res: guide_id });
      })
      .catch(function (error) {
        console.error("Error removing Guide data: ", error.message);
        callback({ pass: false, res: error });
      });
  };

  // A guide's comments, polls and ratings (reviews) — the "discussion",
  // kept with guide_info, not in the guide's content. Counts for the
  // owner's "Clear … and delete discussion" choice (2026-10-17).
  static countGuideDiscussion = async (guide_info_id) => {
    const counts = { comments: 0, polls: 0, reviews: 0 };
    if (!guide_info_id) return counts;
    const infoRef = firebase.firestore().collection("guide_info").doc(guide_info_id);
    for (const sub of Object.keys(counts)) {
      try {
        counts[sub] = (await infoRef.collection(sub).get()).size;
      } catch (e) {
        console.log(`countGuideDiscussion ${sub}`, e.message);
      }
    }
    return counts;
  };

  // Deletes a guide's comments, reviews (ratings) and polls. Each kind on
  // its own, in batches under Firestore's 500-write limit; a refusal (the
  // rules let only a review's author delete it, unless the owner rule is
  // published) is logged and skipped rather than stopping the rest. Unless
  // keepRatingSummary (the guide is being deleted anyway), the guide's
  // rating/num_ratings are recomputed from whatever reviews are left.
  static deleteGuideDiscussion = async (guide_info_id, { keepRatingSummary = false } = {}) => {
    if (!guide_info_id) return;
    const db = firebase.firestore();
    const infoRef = db.collection("guide_info").doc(guide_info_id);
    for (const sub of ["comments", "reviews", "polls"]) {
      try {
        const snap = await infoRef.collection(sub).get();
        for (let i = 0; i < snap.docs.length; i += 400) {
          const batch = db.batch();
          snap.docs.slice(i, i + 400).forEach((d) => batch.delete(d.ref));
          await batch.commit();
        }
      } catch (e) {
        console.log(`deleteGuideDiscussion: could not delete ${sub}`, e.message);
      }
    }
    if (keepRatingSummary) return;
    try {
      const left = (await infoRef.collection("reviews").get()).docs.map((d) => Number(d.data().rating)).filter(Number.isFinite);
      const rating = left.length ? left.reduce((a, b) => a + b, 0) / left.length : 0;
      // comment_count drives the "you have comments" banner — match it to
      // the comments left too.
      const comment_count = (await infoRef.collection("comments").get()).size;
      await infoRef.update({ rating, num_ratings: left.length, comment_count });
    } catch (e) {
      console.log("deleteGuideDiscussion: rating summary", e.message);
    }
  };

  static deleteGuideInfo = async (guide_info_id, callback) => {
    if (DataBase._isGuest(firebase.auth().currentUser?.uid)) { DataBase._guestBlock(callback); return; }
    const db = firebase.firestore();
    const infoRef = db.collection("guide_info").doc(guide_info_id);
    try {
      // Firestore doesn't cascade-delete subcollections when a parent doc is
      // deleted — without this, every comments/reviews/polls doc under this
      // guide is orphaned forever (polls were left out until 2026-10-17).
      await DataBase.deleteGuideDiscussion(guide_info_id, { keepRatingSummary: true });
      await infoRef.delete();
      //console.log("Guide info successfully deleted!");
      callback({ pass: true, res: guide_info_id });
    } catch (error) {
      console.error("Error removing Guide info: ", error.message);
      callback({ pass: false, res: error });
    }
  };

  // static deleteGuideTransaction = (guide_info_id, guide_id, callback) => {
  //   const db = firebase.firestore();
  //   db.collection("guide_info")
  //     .doc(guide_info_id)
  //     .delete()
  //     .then(function () {
  //       //console.log("Guide info successfully deleted!");
  //       callback({ pass: true, res: guide_info_id });
  //     })
  //     .catch(function (error) {
  //       console.error("Error removing Guide info: ", error.message);
  //       callback({ pass: false, res: error });
  //     });
  // };

  // static deleteGuideInfos = (uid, callback) => {
  //   const db = firebase.firestore();
  //   var guide_info_Ref = db.collection("guide_info");
  //   var guide_data_Ref = db.collection("guide_data");

  //   db.runTransaction(function (transaction) {
  //     var info_count = 0;
  //     var data_count = 0;
  //     let data_docs = [];
  //     return transaction.get(guide_info_Ref).then(function (querySnapshot) {
  //       querySnapshot.forEach(function (doc) {
  //         if (doc.data().user_id === id) {
  //           //transaction.delete(doc.ref);
  //           info_count = info_count + 1;
  //           data_docs.push(doc.data().guide_id)
  //         }
  //       });
  //     });
  //   })
  //     .then(function (info_count) {
  //       console.log("guide info ", info_count);
  //       console.log("guide data ", data_count);
  //       callback({ pass: true, guide_info: info_count, guide_data: data_count, data_docs: data_docs });
  //     })
  //     .catch(function (err) {
  //       console.error(err);
  //       callback({ pass: false, guide_info: info_count, guide_data: data_count, data_docs: data_docs });
  //     });
  // };

  static getUserGuideDocIDs = (uid, callback) => {
    const db = firebase.firestore();
    var guide_info_Ref = db.collection("guide_info").where("user_id", "==", uid);
    let guide_data_ids = [];
    let guide_info_ids = [];
    guide_info_Ref
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          guide_data_ids.push(doc.data().guide_id);
          guide_info_ids.push(doc.id);
        });
        callback({ pass: true, guide_info_ids: guide_info_ids, guide_data_ids: guide_data_ids, error: "" });
      })
      .catch((error) => {
        console.log("Error getting all guide infos from Firebase:", error.message);
        callback({ pass: false, guide_info_ids: guide_info_ids, guide_data_ids: guide_data_ids, error: error });
      });
  };

  static removeGuidesFromIDs(guide_info_ids, guide_data_ids, callback) {
    if (DataBase._isGuest(firebase.auth().currentUser?.uid)) { DataBase._guestBlock(callback); return; }
    if (guide_info_ids.length === 0 && guide_data_ids.length === 0) {
      callback({ pass: true, error: "" });
      return;
    }
    const db = firebase.firestore();
    let batch = db.batch();
    // let guide_info_Ref = db.collection("guide_info");
    // let guide_data_Ref = db.collection("guide_data");
    guide_info_ids.forEach((guide_info_id) => {
      batch.delete(db.collection("guide_info").doc(guide_info_id));
    });
    guide_data_ids.forEach((guide_data_id) => {
      batch.delete(db.collection("guide_data").doc(guide_data_id));
    });

    batch
      .commit()
      .then(() => {
        callback({ pass: true, error: "" });
      })
      .catch((error) => {
        console.log("removeGuidesFromIDs error", error.message);
        callback({ pass: false, error: error });
      });
  }

  // static addReview = (guide_info_id, review, callback) => {
  //   // this.rating = rating;
  //   // this.comment = comment;
  //   // this.user_id = user_info.uid;
  //   // this.user_name = `${user_info.first_name} ${user_info.last_name}`;
  //   // this.date = DateTime.utc().toISO();
  //   review.date = DateTime.utc().toISO();

  //   var db = firebase.firestore();
  //   db.collection("guide_info")
  //     .doc(guide_info_id)
  //     .collection("reviews")
  //     .doc(review.user_id)
  //     .set({ ...review })
  //     .then((docRef) => {
  //       callback({ pass: true, res: docRef.id });
  //     })
  //     .catch((error) => {
  //       callback({ pass: false, res: error });
  //     });
  // };

  static reviewExists = (guide_info_id, user_id, callback) => {
    var db = firebase.firestore();
    var DocRef = db.collection("guide_info").doc(guide_info_id).collection("reviews").doc(user_id);
    DocRef.get().then((docSnapshot) => {
      if (docSnapshot.exists) {
        DocRef.onSnapshot((doc) => {
          //console.log(doc.data());
          callback({ pass: true, review: doc.data() });
        });
      } else {
        //console.log("Review does not exist");
        callback({ pass: false, review: null });
        //DocRef.set(); // create the document
      }
    }).catch((error) => {
      console.log("Error checking review existence:", error.message);
      callback({ pass: false, review: null });
    });
  };

  static addReviewTransaction = (guide_info_id, review, callback) => {
    if (DataBase._isGuest(review?.user_id)) { DataBase._guestBlock(callback); return; }
    //console.log(review);
    var db = firebase.firestore();
    var infoDocRef = db.collection("guide_info").doc(guide_info_id);
    var reviewDocRef = db.collection("guide_info").doc(guide_info_id).collection("reviews").doc(review.user_id);
    return db
      .runTransaction((transaction) => {
        return transaction.get(infoDocRef).then((infoDoc) => {
          if (!infoDoc.exists) throw new Error("Guide info not found");
          return transaction.get(reviewDocRef).then((reviewDoc) => {
            var num_ratings = infoDoc.data().num_ratings;
            if (isNaN(num_ratings)) num_ratings = 0;
            var rating = infoDoc.data().rating;
            if (isNaN(rating)) rating = 0;
            if (!reviewDoc.exists) {
              //new rating
              rating = (rating * num_ratings + review.rating) / (num_ratings + 1);
              num_ratings = num_ratings + 1;
            } else {
              //update existing review
              rating = (rating * num_ratings - reviewDoc.data().rating + review.rating) / num_ratings;
            }
            transaction.update(infoDocRef, { rating: rating, num_ratings: num_ratings });
            transaction.set(reviewDocRef, { ...review });
          });
        });
      })
      .then(() => {
        //console.log("Add Review Transaction successfully committed!");
        callback({ pass: true, error: "" });
      })
      .catch((error) => {
        //console.log("Add Review Transaction failed: ", error.message);
        callback({ pass: false, error: error });
      });
  };

  static incrementCopiesTransaction = (guide_info_id, callback) => {
    if (DataBase._isGuest(firebase.auth().currentUser?.uid)) { DataBase._guestBlock(callback); return; }
    // Copying a never-saved (local) guide has no source guide_info to count against.
    if (!guide_info_id) { callback({ pass: false, error: "No source guide_info_id" }); return; }
    var db = firebase.firestore();
    var infoDocRef = db.collection("guide_info").doc(guide_info_id);
    return db
      .runTransaction((transaction) => {
        return transaction.get(infoDocRef).then((infoDoc) => {
          if (!infoDoc.exists) throw new Error("Guide info not found");
          var times_copied = infoDoc.data().times_copied;
          if (isNaN(times_copied)) times_copied = 0;
          times_copied += 1;
          transaction.update(infoDocRef, { times_copied: times_copied });
        });
      })
      .then(() => {
        //console.log("Increment Copies Transaction successful!, times_copied:", times_copied);
        callback({ pass: true, error: "" });
      })
      .catch((error) => {
        //console.log("Increment Copies Transaction failed: ", error.message);
        callback({ pass: false, error: error });
      });
  };

  static lockGuideTransaction = (guide_info_id, user_id, hours, callback) => {
    if (DataBase._isGuest(user_id)) { DataBase._guestBlock(callback); return; }
    var db = firebase.firestore();
    var infoDocRef = db.collection("guide_info").doc(guide_info_id);
    return db
      .runTransaction((transaction) => {
        return transaction.get(infoDocRef).then((infoDoc) => {
          if (!infoDoc.exists) throw new Error("Guide info not found");
          var locked_until = infoDoc.data().locked_until;
          var locked_by = infoDoc.data().locked_by;
          if (typeof locked_until == "undefined") locked_until = DateTime.utc().toISO();
          if (typeof locked_by == "undefined") locked_by = "";
          if (locked_until < DateTime.utc().toISO()) {
            locked_by = user_id;
            locked_until = DateTime.utc().plus({ hours: hours }).toISO();
          }
          transaction.update(infoDocRef, { locked_until: locked_until, locked_by: locked_by });
        });
      })
      .then(() => {
        //console.log("Lock Guide Transaction successful!, locked_until:", locked_until, " by: ", locked_by);
        callback({ pass: true, error: "" });
      })
      .catch((error) => {
        //console.log("Lock Guide Transaction failed: ", error.message);
        callback({ pass: false, error: error });
      });
  };

  static unlockGuideTransaction = (guide_info_id, user_id, hours, callback) => {
    if (DataBase._isGuest(user_id)) { DataBase._guestBlock(callback); return; }
    var db = firebase.firestore();
    var infoDocRef = db.collection("guide_info").doc(guide_info_id);
    return db
      .runTransaction((transaction) => {
        return transaction.get(infoDocRef).then((infoDoc) => {
          if (!infoDoc.exists) throw new Error("Guide info not found");
          var locked_until = infoDoc.data().locked_until;
          var locked_by = infoDoc.data().locked_by;
          if (typeof locked_until == "undefined") locked_until = DateTime.utc().toISO();
          if (typeof locked_by == "undefined") locked_by = "";
          if (locked_by === user_id) {
            locked_until = DateTime.utc().toISO();
            locked_by = "";
          } else {
            callback({ pass: false, error: "This guide is not locked by you" });
            return;
          }
          transaction.update(infoDocRef, { locked_until: locked_until, locked_by: locked_by });
        });
      })
      .then(() => {
        //console.log("Unlock Guide Transaction successful!, locked_until:", locked_until, " by: ", locked_by);
        callback({ pass: true, error: "" });
      })
      .catch((error) => {
        //console.log("Unlock Guide Transaction failed: ", error.message);
        callback({ pass: false, error: error });
      });
  };

  static doesGuideInfoExist = (guide_info_id, callback) => {
    var db = firebase.firestore();
    var docRef = db.collection("guide_info").doc(guide_info_id);
    docRef
      .get()
      .then((doc) => {
        if (doc.exists) {
          callback({ pass: true, error: "" });
        } else {
          callback({ pass: false, error: "" });
        }
      })
      .catch((error) => {
        console.log("Error getting document:", error.message);
        callback({ pass: false, error: error });
      });
  };

  // opts.peek: read the guide's data without it counting as someone opening
  // the guide (the Admin Dashboard's lookup, Build My Trip taking places from
  // a guide) — no guide_view, and it doesn't become "the guide now open".
  static readGuideTransaction = (guide_info_id, callback, uid, opts) => {
    console.log("readGuideTransaction", guide_info_id, uid);
    var db = firebase.firestore();
    var _dataDoc = null;
    var _infoDoc = null;
    var _ownerDoc = null;
    var _creatorDoc = null;
    var dataDocRef = null;
    var ownerDocRef = null;
    var creatorDocRef = null;
    var infoDocRef = db.collection("guide_info").doc(guide_info_id);
    return db
      .runTransaction((transaction) => {
        return transaction.get(infoDocRef).then((infoDoc) => {
          if (!infoDoc.exists) throw new Error("Guide info not found");
          _infoDoc = infoDoc;
          dataDocRef = db.collection("guide_data").doc(infoDoc.data().guide_id);
          return transaction.get(dataDocRef).then((dataDoc) => {
            if (!dataDoc.exists) throw new Error("Guide data not found");
            //console.log("infoDoc.data()", infoDoc.data());
            _dataDoc = dataDoc;

            db.collection("users")
              .where("uid", "==", infoDoc.data().user_id)
              .get()
              .then((querySnapshot) => {
                if (!querySnapshot.empty) _ownerDoc = querySnapshot.docs[0];
                console.log("_ownerDoc", _ownerDoc);
              });

            if (typeof infoDoc.data().creator_id != "undefined" && infoDoc.data().creator_id != "") {
              db.collection("users")
                .where("uid", "==", infoDoc.data().creator_id)
                .get()
                .then((querySnapshot) => {
                  if (!querySnapshot.empty) _creatorDoc = querySnapshot.docs[0];
                  else _creatorDoc = _ownerDoc;
                  console.log("_creatorDoc", _creatorDoc);
                });
            }

            // ownerDocRef = db.collection("users").doc(infoDoc.data().user_id);
            // transaction.get(ownerDocRef).then((ownerDoc) => {
            //   _ownerDoc = ownerDoc;
            //   console.log("ownerDoc.data()", ownerDoc.data());
            // });
            // if (typeof infoDoc.data().creator_id != "undefined" && infoDoc.data().creator_id != "") {
            //   creatorDocRef = db.collection("users").doc(infoDoc.data().creator_id);
            //   transaction.get(creatorDocRef).then((creatorDoc) => {
            //     _creatorDoc = creatorDoc;
            //     console.log("_creatorDoc.data()", _creatorDoc.data());
            //   });
            // } else _creatorDoc = _ownerDoc;
          });
        });
      })
      .then(() => {
        //console.log("readGuideTransaction successful!");
        // Bumping times_read is a best-effort analytics counter, not part of
        // the read itself — done as a separate update outside the
        // transaction so a read-only/copy-only sharee (who can read this doc
        // but fails hasModifyAccess on update, per FirebaseRulesPhase1.txt)
        // doesn't have their entire guide load fail because of it.
        if (uid !== "guest") {
          var times_read = _infoDoc.data().times_read;
          if (isNaN(times_read)) times_read = 0;
          times_read = times_read + 1;
          infoDocRef.update({ times_read: times_read }).catch((error) => {
            console.log("readGuideTransaction times_read update failed: ", error.message);
          });
        }
        callback({
          pass: true,
          error: "",
          guide_id: dataDocRef.id,
          res: _dataDoc.data(),
          infoDoc: _infoDoc.data(),
          guide_info_id: guide_info_id,
          owner_info: _ownerDoc == null ? null : _ownerDoc.data(),
          creator_info: _creatorDoc == null ? null : _creatorDoc.data(),
        });
        ReactGA.event({
          category: "Guide Access",
          action: "Guide Read",
          label: dataDocRef.id,
        });
        if (uid !== "guest") {
          logAnalyticsEvent("guide_read", { uid, guide_id: guide_info_id });
        }
        if (!opts?.peek) logGuideView(guide_info_id, _infoDoc.data());
      })
      .catch((error) => {
        console.log("readGuideTransaction failed: ", error.message);
        callback({ pass: false, error: error, res: null, infoDoc: null });
      });
  };

  // Admin Dashboard support (see memory: DIY Firestore analytics plan) —
  // fetch-all-and-aggregate-client-side, no precomputed counters/Cloud
  // Functions. Fine at this app's scale; revisit only if it gets slow.
  static getAllUsersAndGuides = (callback) => {
    const db = firebase.firestore();
    // the admin reads everyone's private record too (emails moved there 2026-11-01)
    Promise.all([db.collection("users").get(), db.collection("guide_info").get(), db.collection("user_private").get().catch(() => null)])
      .then(([usersSnap, guidesSnap, privSnap]) => {
        const priv = Object.fromEntries((privSnap ? privSnap.docs : []).map((d) => [d.id, d.data()]));
        callback({
          pass: true,
          users: usersSnap.docs.map((d) => mergeUser(d.data(), priv[d.data().uid] || null)),
          guides: guidesSnap.docs.map((d) => ({ id: d.id, ...d.data() })),
        });
      })
      .catch((error) => {
        callback({ pass: false, error });
      });
  };

  static getAnalyticsEvents = (sinceDate, callback) => {
    const db = firebase.firestore();
    db.collection("analytics_events")
      .where("ts", ">=", sinceDate)
      .get()
      .then((snap) => {
        callback({ pass: true, events: snap.docs.map((d) => d.data()) });
      })
      .catch((error) => {
        callback({ pass: false, error });
      });
  };

  // Bypasses the normal per-user access-gated GuideEditModal flow — the
  // admin-unlocked "Featured" toggle needs to work on ANY guide, not just
  // ones the admin account happens to own/have edit access to.
  // Featuring also adds "Copy for all users" (All_C) when the guide has no
  // community grant — see batchedWriteGuide's matching comment. Un-featuring
  // leaves access alone. arrayUnion only appends, matching the admin rule
  // on guide_info (type + appending All_C only). 2026-10-09.
  // Admin Dashboard "Main schedules" fix (FeaturedMainSchedulePanel): every
  // Featured guide's info + parsed data. callback({ pass, guides: [{ guide_info_id,
  // guide_id, name, owner, data }] }). 2026-10-26.
  static getFeaturedGuidesData = (callback) => {
    const db = firebase.firestore();
    db.collection("guide_info")
      .where("type", "==", "Featured")
      .get()
      .then((snap) =>
        Promise.all(
          snap.docs.map((doc) => {
            const info = doc.data();
            if (!info.guide_id) return null;
            return db
              .collection("guide_data")
              .doc(info.guide_id)
              .get()
              .then((d) => {
                if (!d.exists) return null;
                let data = null;
                try { data = JSON.parse(d.data().data); } catch (e) { return null; }
                return { guide_info_id: doc.id, guide_id: info.guide_id, name: info.guide_name, owner: d.data().user_id, type: info.type || "", access: Array.isArray(info.access) ? info.access : [], data };
              });
          })
        )
      )
      .then((guides) => callback({ pass: true, guides: guides.filter(Boolean) }))
      .catch((error) => callback({ pass: false, error }));
  };

  // The same shape for guides named by guide_info id (Admin Dashboard → Guides fixes for guides that
  // aren't Featured yet, 2026-10-31). Guides that can't be read are left out.
  static getGuidesDataByInfoIds = (ids, callback) => {
    const db = firebase.firestore();
    Promise.all(
      (ids || []).map((id) =>
        db.collection("guide_info").doc(id).get().then((doc) => {
          const info = doc.exists ? doc.data() : null;
          if (!info || !info.guide_id) return null;
          return db.collection("guide_data").doc(info.guide_id).get().then((d) => {
            if (!d.exists) return null;
            let data = null;
            try { data = JSON.parse(d.data().data); } catch (e) { return null; }
            return { guide_info_id: doc.id, guide_id: info.guide_id, name: info.guide_name, owner: d.data().user_id, type: info.type || "", access: Array.isArray(info.access) ? info.access : [], data };
          });
        }).catch(() => null)
      )
    )
      .then((guides) => callback({ pass: true, guides: guides.filter(Boolean) }))
      .catch((error) => callback({ pass: false, error }));
  };

  // Rewrites only guide_data's `data` field (owner fields untouched, unlike
  // updateGuideData's set()). Allowed only for the guide's owner.
  static replaceGuideDataContent = (guide_id, data, callback) => {
    const json = JSON.stringify(data, Place.storageReplacer);
    if (!DataBase._sizeGate(json, callback)) return;
    firebase
      .firestore()
      .collection("guide_data")
      .doc(guide_id)
      .update({ data: json })
      .then(() => callback({ pass: true }))
      .catch((error) => callback({ pass: false, error }));
  };

  // Lets another account modify a guide (its uid added to guide_info.access; a bare uid = Modify).
  // Admin Dashboard → Guides fixes ("share"), 2026-10-31. Allowed for the owner by the rules.
  static addGuideModifyAccess = (guide_info_id, uid, callback) => {
    firebase.firestore().collection("guide_info").doc(guide_info_id)
      .update({ access: firebase.firestore.FieldValue.arrayUnion(uid) })
      .then(() => callback({ pass: true }))
      .catch((error) => callback({ pass: false, error }));
  };

  static setGuideFeatured = (guide_info_id, featured, callback) => {
    const db = firebase.firestore();
    const ref = db.collection("guide_info").doc(guide_info_id);
    ref
      .get()
      .then((doc) => {
        const access = Array.isArray(doc.data()?.access) ? doc.data().access : [];
        const hasCommunity = access.some((a) => typeof a === "string" && a.startsWith("All_"));
        const update = { type: featured ? "Featured" : "" };
        if (featured && !hasCommunity) update.access = firebase.firestore.FieldValue.arrayUnion("All_C");
        return ref.update(update);
      })
      .then(() => callback({ pass: true }))
      .catch((error) => callback({ pass: false, error }));
  };

  // Lets the Admin Dashboard set/clear the announcement banner (settings/
  // settings doc's `announce` field, read once per load by
  // MobileBottomNavBar.js's readSettingsCallback) without needing to edit
  // Firestore directly. Added 2026-08-29 — see memory:
  // project_cost_revenue_viability.
  // platforms: array subset of ["ios","android","web"] — which clients show
  // this announcement. Empty/missing (or all three) means everyone, same as
  // the original behavior before platform-targeting existed. testOnly:
  // restricts it to dev/test builds only (__DEV__ on mobile, non-production
  // NODE_ENV on web) — lets an admin preview an announcement without
  // publishing it to real users at all. Requested 2026-09-28.
  static updateAnnounce = (html, platforms, testOnly, callback) => {
    const db = firebase.firestore();
    db.collection("settings")
      .doc("settings")
      .update({ announce: html, announce_platforms: platforms || [], announce_test_only: !!testOnly })
      .then(() => callback({ pass: true }))
      .catch((error) => callback({ pass: false, error }));
  };

  // Per-platform version gate — a client on a platform below ITS OWN
  // version shows a persistent "please update"/"please refresh" prompt on
  // every launch instead of Announce's one-shot message. versions:
  // { ios, android, web } (any key blank/missing disables the gate for that
  // platform). Requested 2026-09-28 — see project memory:
  // project_firestore_rules_hardening.
  static updateMinSupportedVersion = (versions, callback) => {
    const db = firebase.firestore();
    db.collection("settings")
      .doc("settings")
      .update({ min_supported_version: versions })
      .then(() => callback({ pass: true }))
      .catch((error) => callback({ pass: false, error }));
  };

  static getAllGuideReviews = (guide_info_id, callback) => {
    //console.log("getAllGuideReviews", guide_info_id);
    let reviews = [];
    const db = firebase.firestore();
    var docRef = db.collection("guide_info").doc(guide_info_id).collection("reviews");
    docRef
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          //console.log("querySnapshot.forEach:", doc.data());
          reviews.push({ id: doc.id, data: doc.data() });
        });
        callback({ pass: true, reviews: reviews });
      })
      .catch((error) => {
        console.log("Error getting all guide infos from Firebase:", error.message);
        callback({ pass: false, reviews: error });
      });
  };

  // Comments on a specific place or event within a guide — unlike reviews,
  // auto-ID'd (one user can post many) rather than keyed by uid. See
  // docs/FirebaseRulesPhase1.txt's /comments rule for the access model.
  //
  // Also bumps guide_info.comment_count transactionally (same shape as
  // addReviewTransaction's rating/num_ratings bump) so a banner/menu item
  // can show "you have comments" from the already-loaded guide_info doc,
  // without a separate read. The guide_info update this requires is scoped
  // by its own rule (FirebaseRulesPhase1.txt) to ONLY the comment_count
  // field for a Read-access (not just Modify) user — a Read-only
  // commenter's count-bump would otherwise be rejected by the normal
  // MODIFY-only guide_info update rule, same failure mode the times_read
  // fix (readGuideTransaction) already hit once.
  static addComment = (guide_info_id, comment, callback) => {
    if (DataBase._isGuest(comment?.user_id)) { DataBase._guestBlock(callback); return; }
    const db = firebase.firestore();
    const infoDocRef = db.collection("guide_info").doc(guide_info_id);
    const commentDocRef = db.collection("guide_info").doc(guide_info_id).collection("comments").doc();
    db.runTransaction((transaction) => {
      return transaction.get(infoDocRef).then((infoDoc) => {
        if (!infoDoc.exists) throw new Error("Guide info not found");
        var comment_count = infoDoc.data().comment_count;
        if (isNaN(comment_count)) comment_count = 0;
        comment_count = comment_count + 1;
        transaction.update(infoDocRef, { comment_count: comment_count });
        transaction.set(commentDocRef, { ...comment });
      });
    })
      .then(() => {
        callback({ pass: true, id: commentDocRef.id });
      })
      .catch((error) => {
        console.log("addComment failed: ", error.message);
        callback({ pass: false, error: error });
      });
  };

  static getComments = (guide_info_id, target_type, target_id, callback) => {
    let comments = [];
    const db = firebase.firestore();
    db.collection("guide_info")
      .doc(guide_info_id)
      .collection("comments")
      .where("target_type", "==", target_type)
      .where("target_id", "==", target_id)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          comments.push({ id: doc.id, data: doc.data() });
        });
        comments.sort((a, b) => (a.data.date > b.data.date ? 1 : -1));
        callback({ pass: true, comments: comments });
      })
      .catch((error) => {
        console.log("getComments failed: ", error.message);
        callback({ pass: false, comments: error });
      });
  };

  // Fetches every comment across the whole guide (no target filter) — used
  // only by the jump-list, which is opened on demand, unlike getComments
  // above (lazy, per-place/event) or comment_count (free, denormalized).
  static getAllGuideComments = (guide_info_id, callback) => {
    let comments = [];
    const db = firebase.firestore();
    db.collection("guide_info")
      .doc(guide_info_id)
      .collection("comments")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          comments.push({ id: doc.id, data: doc.data() });
        });
        callback({ pass: true, comments: comments });
      })
      .catch((error) => {
        console.log("getAllGuideComments failed: ", error.message);
        callback({ pass: false, comments: error });
      });
  };

  // Self-heal for comment_count: addComment/deleteComment keep it accurate
  // going forward, but a comment created before that counting logic existed
  // (or one deleted by some other path) left it stale/undercounting. The
  // comments jump-list already pays for a full getAllGuideComments read, so
  // it's a free place to recompute the true total and write it back — a
  // plain update (not a transaction; this is a correction, not an
  // increment), covered by the same field-scoped "comment_count only" rule
  // addComment/deleteComment already rely on.
  static setCommentCount = (guide_info_id, count, callback) => {
    const db = firebase.firestore();
    db.collection("guide_info")
      .doc(guide_info_id)
      .update({ comment_count: count })
      .then(() => {
        callback({ pass: true });
      })
      .catch((error) => {
        console.log("setCommentCount failed: ", error.message);
        callback({ pass: false, error: error });
      });
  };

  static deleteComment = (guide_info_id, comment_id, callback) => {
    const db = firebase.firestore();
    const infoDocRef = db.collection("guide_info").doc(guide_info_id);
    const commentDocRef = db.collection("guide_info").doc(guide_info_id).collection("comments").doc(comment_id);
    db.runTransaction((transaction) => {
      return transaction.get(infoDocRef).then((infoDoc) => {
        if (!infoDoc.exists) throw new Error("Guide info not found");
        var comment_count = infoDoc.data().comment_count;
        if (isNaN(comment_count)) comment_count = 0;
        comment_count = Math.max(0, comment_count - 1);
        transaction.update(infoDocRef, { comment_count: comment_count });
        transaction.delete(commentDocRef);
      });
    })
      .then(() => {
        callback({ pass: true, res: comment_id });
      })
      .catch((error) => {
        console.log("deleteComment failed: ", error.message);
        callback({ pass: false, res: error });
      });
  };

  // Simple guide-level polls (Recommendation #3c, the last piece of
  // "collaboration basics" — conflict-safe saves and comments are both
  // shipped). Guide-level only, not per-place/event like comments — no
  // target_type/target_id, and so no need for comments' event-ID-stability
  // workaround (CommentKey/stableEventKey) or a jump-list modal, since
  // there's just one flat list of polls per guide. Votes are a single map
  // field on the poll doc ({uid: optionId}), not a subcollection — simple
  // and sufficient at this scale (a handful of travel companions, not
  // hundreds of voters), avoiding both an extra query per poll and a
  // separate counter to keep in sync. See docs/FirebaseRulesPhase1.txt's
  // /polls rule for the access model (mirrors /comments: create/vote need
  // at least Read access, close/delete needs Modify or the poll's own
  // creator).
  static addPoll = (guide_info_id, poll, callback) => {
    if (DataBase._isGuest(poll?.created_by)) { DataBase._guestBlock(callback); return; }
    const db = firebase.firestore();
    const pollDocRef = db.collection("guide_info").doc(guide_info_id).collection("polls").doc();
    pollDocRef
      .set({ ...poll, votes: {}, closed: false })
      .then(() => {
        callback({ pass: true, id: pollDocRef.id });
      })
      .catch((error) => {
        console.log("addPoll failed: ", error.message);
        callback({ pass: false, error: error });
      });
  };

  static getPolls = (guide_info_id, callback) => {
    let polls = [];
    const db = firebase.firestore();
    db.collection("guide_info")
      .doc(guide_info_id)
      .collection("polls")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          polls.push({ id: doc.id, data: doc.data() });
        });
        // Newest first — unlike comments (a chronological thread, oldest
        // first), a poll list reads more naturally with whatever's most
        // recently asked at the top, same convention the guide library's
        // own "recently added" lists already use.
        polls.sort((a, b) => (a.data.date < b.data.date ? 1 : -1));
        callback({ pass: true, polls: polls });
      })
      .catch((error) => {
        console.log("getPolls failed: ", error.message);
        callback({ pass: false, polls: error });
      });
  };

  // Dot-path field update (votes.<uid>) rather than reading, mutating, and
  // rewriting the whole map — lets two different voters update in parallel
  // without a transaction or risk of clobbering each other's vote, and lets
  // a voter change their own vote by simply calling this again with a
  // different option_id (same field, new value).
  static votePoll = (guide_info_id, poll_id, uid, option_id, callback) => {
    if (DataBase._isGuest(uid)) { DataBase._guestBlock(callback); return; }
    const db = firebase.firestore();
    db.collection("guide_info")
      .doc(guide_info_id)
      .collection("polls")
      .doc(poll_id)
      .update({ [`votes.${uid}`]: option_id })
      .then(() => {
        callback({ pass: true });
      })
      .catch((error) => {
        console.log("votePoll failed: ", error.message);
        callback({ pass: false, error: error });
      });
  };

  // Withdraws a vote entirely (distinct from changing it to a different
  // option) — Firestore's FieldValue.delete() is the only way to remove
  // one key from a map field without reading/rewriting the whole thing.
  static removeVote = (guide_info_id, poll_id, uid, callback) => {
    const db = firebase.firestore();
    db.collection("guide_info")
      .doc(guide_info_id)
      .collection("polls")
      .doc(poll_id)
      .update({ [`votes.${uid}`]: firebase.firestore.FieldValue.delete() })
      .then(() => {
        callback({ pass: true });
      })
      .catch((error) => {
        console.log("removeVote failed: ", error.message);
        callback({ pass: false, error: error });
      });
  };

  // Closing freezes voting without deleting the poll or its results — the
  // creator or a Modify-level collaborator can do this (see the rule file);
  // closed is just a boolean, not a separate lifecycle state, so re-opening
  // is just as simple a toggle back.
  static setPollClosed = (guide_info_id, poll_id, closed, callback) => {
    const db = firebase.firestore();
    db.collection("guide_info")
      .doc(guide_info_id)
      .collection("polls")
      .doc(poll_id)
      .update({ closed: closed })
      .then(() => {
        callback({ pass: true });
      })
      .catch((error) => {
        console.log("setPollClosed failed: ", error.message);
        callback({ pass: false, error: error });
      });
  };

  static deletePoll = (guide_info_id, poll_id, callback) => {
    const db = firebase.firestore();
    db.collection("guide_info")
      .doc(guide_info_id)
      .collection("polls")
      .doc(poll_id)
      .delete()
      .then(() => {
        callback({ pass: true, res: poll_id });
      })
      .catch((error) => {
        console.log("deletePoll failed: ", error.message);
        callback({ pass: false, res: error });
      });
  };

  static DownloadOldGuide = (guide_id, callback, loadGuide, showGuide) => {
    var request = new XMLHttpRequest();
    request.onreadystatechange = function () {
      if (request.readyState == 4) {
        // The request is done; did it work?
        if (request.status === 200) {
          if (request.responseText != null) {
            callback(request.responseText, loadGuide, showGuide);
          } else {
            console.log("Error in DownloadGuide");
            callback(null);
          }
        }
      }
      // else {
      //   console.warn("error downloading guide!", request.status);
      //   callback(null);
      // }
    };
    request.open("GET", `http://www.liquidguides.com/database/download_GuideSections.php?guide_id=${guide_id}`);
    request.send();
  };
}

// Development builds only: lets the Playwright tests (e2e/smoke) set up and
// clean up test data directly — e.g. the share-invitations test creates and
// deletes its own test guides. Never present in the production build.
if (process.env.NODE_ENV === "development" && typeof window !== "undefined") {
  window.__andiamoTest = { firebase, DataBase };
}
